module.exports = __webpack_public_path__ + "img/20.70718be6.png";